export const teklifSiparisTypes = {
  ALINAN_TEKLIF: "Alınan Teklif",
  VERILEN_TEKLIF: "Verilen Teklif",
  ALINAN_SIPARIS: "Alınan Sipariş",
  VERILEN_SIPARIS: "Verilen Sipariş",
};
